// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"z7-z","colorTextValue":"A7-z","swatches":"B7-z","collapseLink":"C7-z","isCollapsed":"D7-z","dropdown":"E7-z","disabled":"F7-z"};